import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import InputGroup from '../../../../../components/global/InputGroup';
import { getAsset } from '../../../../../util/assets';
import Alert from '../../../../../components/global/Alert';
import Button from '../../../../../components/global/Button';
import Spinner from '../../../../../components/global/Spinner';
import Label from '../../../../../components/global/Label';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.shape({
    email: PropTypes.string,
    teamIdentifier: PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  isFormValid: PropTypes.bool,
  onBack: PropTypes.func.isRequired,
  isPasswordResetMode: PropTypes.bool,
  onForgotPassword: PropTypes.func,
  onCancelPasswordReset: PropTypes.func,
};

const AuthModeTeam = ({
  onSubmit,
  values,
  onChange,
  error,
  loading,
  isFormValid,
  onBack,
  isPasswordResetMode,
  onForgotPassword,
  onCancelPasswordReset,
}) => {
  return (
    <Fragment>
      <form className="login-form" onSubmit={onSubmit}>
        <Button
          onClick={onBack}
          btnStyle="link"
          btnSize="sm"
          className="mb-2 p-0"
          data-testid="team-back-button"
        >
          &larr; Back to Business Login
        </Button>
        <Label
          id="team-identifier"
          labelTip="You can find your team identifier on the email received with your team invite."
        >
          Team Identifier
        </Label>
        <InputGroup
          id="team-identifier"
          type="text"
          name="team-identifier"
          addon={<img alt="" src={getAsset('/shutterbug/icons/user.svg')} />}
          placeholder="Team identifier"
          value={values.teamIdentifier}
          onChange={({ target }) => onChange('teamIdentifier', target.value)}
          wrapperClassName="mb-1"
          data-testid="team-identifier-input"
        />
        <Label id="email">Email</Label>
        <InputGroup
          id="email"
          type="email"
          name="email"
          addon={<img alt="" src={getAsset('/shutterbug/icons/email.svg')} />}
          placeholder="Your email address"
          value={values.email}
          onChange={({ target }) => onChange('email', target.value)}
          wrapperClassName="mb-1"
          data-testid="team-email-input"
        />
        {!isPasswordResetMode && (
          <Fragment>
            <Label id="password">Password</Label>
            <InputGroup
              id="password"
              type="password"
              name="password"
              addon={
                <img alt="" src={getAsset('/shutterbug/icons/password.svg')} />
              }
              placeholder="Password"
              value={values.password}
              onChange={({ target }) => onChange('password', target.value)}
              wrapperClassName="mb-1"
              data-testid="team-password-input"
            />
          </Fragment>
        )}

        {error && (
          <Alert type="danger" className="mt-2">
            <strong>
              {isPasswordResetMode
                ? "Password reset request wasn't successful"
                : "Signing in wasn't successful"}
            </strong>
            <br />
            {error}
          </Alert>
        )}
        <div className="text-center">
          <Button
            type="submit"
            className="mt-4 mb-1 login-email-form-button"
            disabled={loading || !isFormValid}
            data-testid={
              isPasswordResetMode
                ? 'team-password-reset-request-button'
                : 'team-sign-in-button'
            }
          >
            {!loading ? (
              isPasswordResetMode ? (
                'Request password reset'
              ) : (
                'Log in'
              )
            ) : (
              <Spinner light size="xs" />
            )}
          </Button>
        </div>
        <div className="text-center">
          {!isPasswordResetMode ? (
            <Button
              onClick={onForgotPassword}
              btnStyle="link"
              btnSize="sm"
              className="p-0"
              data-testid="team-forgot-password-button"
            >
              Forgot your team password?
            </Button>
          ) : (
            <Button
              onClick={onCancelPasswordReset}
              btnStyle="link"
              btnSize="sm"
              className="p-0"
              data-testid="team-cancel-password-reset-button"
            >
              Back to team login
            </Button>
          )}
        </div>
      </form>
    </Fragment>
  );
};

AuthModeTeam.propTypes = propTypes;

export default AuthModeTeam;
